import React from "react";

import { CheckCircle } from "@mui/icons-material";
import { Box, Divider, TableCell, TableRow, Typography } from "@mui/material";
import {
  buildStyles,
  CircularProgressbarWithChildren,
} from "react-circular-progressbar";

import Row from "./Row";

/* =============================================================================
  <ExpandedRow />
  ============================================================================= */
const ExpandedRow = ({
  page,
  resume,
  isRowExpended,
  onExpand,
  selectedRows,
  setSelectedRows,
  onRequestAssesment,
}) => {
  const isNotFlowthree = resume?.job_post_id;
  const isStep1Completed = resume?.resume_id;
  const isStep2Completed = resume?.processing_status === "completed";
  const resume_score = resume?.resume_score;
  const isStep3Completed = resume?.result[0]?.id || resume?.stage === "Invited";
  const isStep4Completed =
    resume?.result[0]?.id || resume?.stage === "Interivew started";
  const isStep5Completed = resume?.result[0]?.id;
  const isStep6Completed = resume?.interview_score;
  const interview_score = resume?.interview_score;

  return (
    <>
      <Row
        isRowExpended={isRowExpended}
        onExpand={onExpand}
        page={page}
        resume={resume}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
        onRequestAssesment={onRequestAssesment}
      />
      <TableRow tabIndex={-1} sx={{ border: "none" }}>
        <TableCell colSpan={10} sx={{ border: "none" }}>
          <Box
            overflow="auto"
            width="95vw"
            px={7}
            pb={2}
            display="flex"
            alignItems="center"
          >
            {isNotFlowthree ? (
              <>
                <Box>
                  <Typography
                    bgcolor={isStep1Completed ? "#5AC4FE" : "#999"}
                    borderRadius="50%"
                    width="18px"
                    fontSize="14px"
                    height="18px"
                    color="white"
                    className="center"
                  >
                    1
                  </Typography>
                  <Typography
                    color="#50636C"
                    fontSize="14px"
                    fontWeight={600}
                    fontFamily="Outfit"
                    my={0.5}
                  >
                    Resume and Form Submitted
                  </Typography>
                  <ColoredBox color={isStep1Completed ? "#5AC4FE" : "#999"}>
                    <Typography
                      color="white"
                      fontWeight={600}
                      display="inline-flex"
                      gap={1}
                    >
                      Completed
                      {isStep1Completed && (
                        <CheckCircle
                          sx={{ fontSize: "20px", color: "white" }}
                        />
                      )}
                    </Typography>
                  </ColoredBox>
                </Box>
                <Divider
                  sx={{ width: "70px", mt: 5, border: 1, color: "#d9d9d9" }}
                />
                <Box>
                  <Typography
                    bgcolor={isStep2Completed ? "#91CC24" : "#999"}
                    borderRadius="50%"
                    width="18px"
                    fontSize="14px"
                    height="18px"
                    color="white"
                    className="center"
                  >
                    2
                  </Typography>
                  <Typography
                    color="#50636C"
                    fontSize="14px"
                    fontWeight={600}
                    fontFamily="Outfit"
                    my={0.5}
                  >
                    Resume Screening
                  </Typography>
                  <ColoredBox color={isStep2Completed ? "#91CC24" : "#999"}>
                    <Typography
                      color="white"
                      fontWeight={600}
                      display="inline-flex"
                      gap={1}
                    >
                      Completed
                      {isStep2Completed && (
                        <CheckCircle
                          sx={{ fontSize: "20px", color: "white" }}
                        />
                      )}
                    </Typography>
                  </ColoredBox>
                </Box>
                <Divider
                  sx={{ width: "70px", mt: 5, border: 1, color: "#d9d9d9" }}
                />
                <Box>
                  <Typography
                    color="#50636C"
                    fontSize="14px"
                    fontWeight={600}
                    fontFamily="Outfit"
                    my={0.5}
                  >
                    Score
                  </Typography>
                  <Box width="40px" height="40px">
                    <CircularProgressbarWithChildren
                      value={resume_score || 0}
                      strokeWidth={11}
                      styles={buildStyles({
                        rotation: 0.2,
                        pathColor: `#91CC24`,
                        trailColor: "transparent",
                      })}
                    >
                      <Typography
                        color={resume_score ? "#91CC24" : "#999"}
                        fontWeight={600}
                        textAlign="center"
                        fontSize="11px"
                        mb={2}
                      >
                        {`${resume_score || 0}%`}
                      </Typography>
                    </CircularProgressbarWithChildren>
                  </Box>
                </Box>
                <Divider
                  sx={{ width: "70px", mt: 5, border: 1, color: "#d9d9d9" }}
                />
              </>
            ) : null}
            <Box>
              <Typography
                bgcolor={isStep3Completed ? "#9852D6" : "#999"}
                borderRadius="50%"
                width="18px"
                fontSize="14px"
                height="18px"
                color="white"
                className="center"
              >
                {isNotFlowthree ? 3 : 1}
              </Typography>
              <Typography
                color="#50636C"
                fontSize="14px"
                fontWeight={600}
                fontFamily="Outfit"
                my={0.5}
              >
                Interview Assessment Sent
              </Typography>
              <ColoredBox color={isStep3Completed ? "#9852D6" : "#999"}>
                <Typography
                  color="white"
                  fontWeight={600}
                  display="inline-flex"
                  gap={1}
                >
                  Completed
                  {isStep3Completed && (
                    <CheckCircle sx={{ fontSize: "20px", color: "white" }} />
                  )}
                </Typography>
              </ColoredBox>
            </Box>
            <Divider
              sx={{ width: "70px", mt: 5, border: 1, color: "#d9d9d9" }}
            />
            <Box>
              <Typography
                bgcolor={isStep4Completed ? "#FFB200" : "#999"}
                borderRadius="50%"
                width="18px"
                fontSize="14px"
                height="18px"
                color="white"
                className="center"
              >
                {isNotFlowthree ? 4 : 2}
              </Typography>
              <Typography
                color="#50636C"
                fontSize="14px"
                fontWeight={600}
                fontFamily="Outfit"
                my={0.5}
              >
                Interview started
              </Typography>
              <ColoredBox color={isStep4Completed ? "#FFB200" : "#999"}>
                <Typography
                  color="white"
                  fontWeight={600}
                  display="inline-flex"
                  gap={1}
                >
                  Completed
                  {isStep4Completed && (
                    <CheckCircle sx={{ fontSize: "20px", color: "white" }} />
                  )}
                </Typography>
              </ColoredBox>
            </Box>
            <Divider
              sx={{ width: "70px", mt: 5, border: 1, color: "#d9d9d9" }}
            />
            <Box>
              <Typography
                bgcolor={isStep5Completed ? "#5AC4FE" : "#999"}
                borderRadius="50%"
                width="18px"
                fontSize="14px"
                height="18px"
                color="white"
                className="center"
              >
                {isNotFlowthree ? 5 : 3}
              </Typography>
              <Typography
                color="#50636C"
                fontSize="14px"
                fontWeight={600}
                fontFamily="Outfit"
                my={0.5}
              >
                Interview completed
              </Typography>
              <ColoredBox color={isStep5Completed ? "#5AC4FE" : "#999"}>
                <Typography
                  color="white"
                  fontWeight={600}
                  display="inline-flex"
                  gap={1}
                >
                  Completed
                  {isStep5Completed && (
                    <CheckCircle sx={{ fontSize: "20px", color: "white" }} />
                  )}
                </Typography>
              </ColoredBox>
            </Box>
            <Divider
              sx={{ width: "70px", mt: 5, border: 1, color: "#d9d9d9" }}
            />
            <Box>
              <Typography
                bgcolor={isStep6Completed ? "#91CC24" : "#999"}
                borderRadius="50%"
                width="18px"
                fontSize="14px"
                height="18px"
                color="white"
                className="center"
              >
                {isNotFlowthree ? 6 : 4}
              </Typography>
              <Typography
                color="#50636C"
                fontSize="14px"
                fontWeight={600}
                fontFamily="Outfit"
                my={0.5}
              >
                Interview Results Generated
              </Typography>
              <ColoredBox color={isStep6Completed ? "#91CC24" : "#999"}>
                <Typography
                  color="white"
                  fontWeight={600}
                  display="inline-flex"
                  gap={1}
                >
                  Completed
                  {isStep6Completed && (
                    <CheckCircle sx={{ fontSize: "20px", color: "white" }} />
                  )}
                </Typography>
              </ColoredBox>
            </Box>
            <Divider
              sx={{ width: "70px", mt: 5, border: 1, color: "#d9d9d9" }}
            />
            <Box>
              <Typography
                color="#50636C"
                fontSize="14px"
                fontWeight={600}
                fontFamily="Outfit"
                my={0.5}
              >
                Score
              </Typography>
              <Box width="40px" height="40px">
                <CircularProgressbarWithChildren
                  value={interview_score || 0}
                  strokeWidth={11}
                  styles={buildStyles({
                    // Text size
                    rotation: 0.2,
                    // Colors
                    pathColor: `#91CC24`,
                    trailColor: "transparent",
                  })}
                >
                  <Typography
                    color={interview_score ? "#91CC24" : "#999"}
                    fontWeight={600}
                    textAlign="center"
                    fontSize="13px"
                    mb={2}
                  >
                    {`${interview_score || 0}%`}
                  </Typography>
                </CircularProgressbarWithChildren>
              </Box>
            </Box>
          </Box>
        </TableCell>
      </TableRow>
    </>
  );
};

const ColoredBox = ({ color, disable, children, ...props }) => (
  <Box
    p={2}
    bgcolor={color}
    sx={{ opacity: disable ? 0.4 : 1 }}
    borderRadius="10px"
    width="180px"
    className="center"
    minHeight="#5AC4FE"
    {...props}
  >
    {disable ? (
      <Typography color="white" fontWeight={600} display="inline-flex" gap={1}>
        In-queue
      </Typography>
    ) : (
      children
    )}
  </Box>
);

/* Export
  ============================================================================= */
export default ExpandedRow;
